export interface User {
  username: string;
  email: string;
  server: ServerChoices;
  ign?: string;
  isTrading?: boolean;
  passwordHash?: string;
  confirmed?: number; // Added for email verification
  publicMonsters?: boolean;
  publicMissing?: boolean;
  game?: GameChoices; // Added game field
}

export interface Monster {
  monsterId: number;
  name: string;
  step: number;
  base?: number;
  type: MonsterType;
  img: string;
  acquired?: boolean;
  count: number;
}

export interface UserMonster {
  email: string;
  monsterId: number;
  count: number;
}

export interface State {
  email?: string;
  ign?: string; // Add ign to the state
}

export interface TradePartner {
  partnerIgn: string;
  userIsInterestedIn: Monster[];
  partnerIsInterestedIn: Monster[];
}

export type MonsterType = "all" | "normal" | "archi" | "boss" | "monster";

export type ServerChoices = "Dakal" | "Draconiros" | "Kourial" | "Mikhal" | "Brial" | "Hell Mina" | "Imagiro" | "Orukam" | "Rafal" | "Salar" | "Tal Kasha" | "Tylezia" | "Ombre" | "Beta 1";

export type GameChoices = "Dofus 3" | "Dofus Retro" | "Dofus Touch"; // Added GameChoices type

export const gameOptions: GameChoices[] = [ // Added gameOptions
  "Dofus 3",
  "Dofus Retro",
  "Dofus Touch",
];

export const serverOptions: ServerChoices[] = [
  "Dakal", "Draconiros", "Kourial", "Mikhal", "Brial", "Hell Mina", 
  "Imagiro", "Orukam", "Rafal", "Salar", "Tal Kasha", "Tylezia", 
  "Ombre"
];